import { render, staticRenderFns } from "./SubmissionUpdateForm.vue?vue&type=template&id=299e30ef&scoped=true&"
import script from "./SubmissionUpdateForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionUpdateForm.vue?vue&type=style&index=0&id=299e30ef&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e30ef",
  null
  
)

/* custom blocks */
import block0 from "./SubmissionUpdateForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports